import { Injectable } from '@angular/core';

export type ThemeType = 'light' | 'dark';

const THEME_STORAGE_KEY = 'sso_theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private current: ThemeType = 'light';

  constructor() {
    this.current = (localStorage.getItem(THEME_STORAGE_KEY) as ThemeType) || 'light';
    this.applyToDom();
  }

  getTheme(): ThemeType {
    return this.current;
  }

  setTheme(theme: ThemeType): void {
    if (this.current === theme) return;
    this.current = theme;
    localStorage.setItem(THEME_STORAGE_KEY, theme);
    this.applyToDom();
  }

  isDark(): boolean {
    return this.current === 'dark';
  }

  private applyToDom(): void {
    const body = document.body;
    if (this.current === 'dark') {
      body.classList.add('theme-dark');
    } else {
      body.classList.remove('theme-dark');
    }
  }
}
